(ns app.front.view.party.requirements
  (:require ["@carbon/icons-react/es/connect/24" :default Connect24]
            ["@carbon/icons-react/es/face--add/24" :default FaceAdd24]
            ["@carbon/icons-react/es/information--disabled/24" :default InfoDisabled24]
            ["@carbon/icons-react/es/trash-can/24" :default TrashCan24]
            ["@carbon/icons-react/es/user--profile/24" :default Person24]
            [app.domain.party.model :as party-model]
            [app.domain.requirement.model :as req-model]
            [app.front.process :as process]
            [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.party.common :as party-common]
            [app.front.view.party.registered-contractor :as party-registered-contractor]
            [app.front.view.party.subs-req :as party-req-subs]
            [app.front.view.workspace.subs :as ws-subs]
            [app.i18n.model :as i18n-model]
            [clojure.set :as set]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-sub ::add-required-role-dropdown-open?
  (fn [db [_ parent-id]]
    (contains? (get db ::add-required-role-dropdown-open? #{}) parent-id)))

(rf/reg-event-db ::set-add-required-role-dropdown-open
  (fn [db [_ parent-id open?]]
    (update db ::add-required-role-dropdown-open? (fnil (if open? conj disj) #{}) parent-id)))

(rf/reg-event-db ::open-add-required-role-dropdown
  (fn [db [_ parent-id]]
    (update db ::add-required-role-dropdown-open? (fnil conj #{}) parent-id)))

(def action->icon
  {:add-party-from-cr    Person24
   :assign-role-to-party Connect24
   :apply-wo-role        InfoDisabled24
   :add-new-party        FaceAdd24
   :remove-required-role TrashCan24})

(defn- label-element [role-name tr e]
  (let [label (-> e (futil/oget :label) keyword)]
    (r/as-element
      [:div.flex
       (r/create-element (get action->icon label Person24) #js{:aria-label (tr [(keyword "party" label)])})
       [:div.ml-3 (if (= label :apply-wo-role)
                    (tr [(keyword "party" label)]
                        [role-name])
                    (tr [(keyword "party" label)]))]])))

(defn required-role-item [{:keys [add-party-permitted? parties party-role lang missing-roles parent requirement tr parties-w-missing-trade+role-ids]}]
  (let [parent-id                   (:db/id parent)
        role-name                   (i18n-model/get-text-from-entities-or-map (:party-role/names party-role) lang)
        required-trade              (:party-role/trade party-role)
        trade-name                  (i18n-model/get-text-from-entities-or-map (:group.config/names required-trade) lang)
        role-missing                (missing-roles party-role)
        parties-in-role             (set (filter #(contains? (->> (:party/party-roles %)
                                                                  (map :db/id)
                                                                  set)
                                                             (:db/id party-role))
                                                 parties))
        role-ids-with-missing-trade (->> parties-w-missing-trade+role-ids
                                         vals
                                         (apply concat)
                                         set)
        trade-missing?              (and required-trade
                                         ;; if some party has this role and doesn't have the required trade -> show warning border
                                         ;; even though only one party needs to fulfill the trade requirement
                                         (role-ids-with-missing-trade (:db/id party-role)))
        parties-in-role-count       (count parties-in-role)]
    [:div.required-roles-button.flex
     {:title   role-name
      :data-cy "required-roles"
      :key     (str (:db/id party-role) "-party")}
     (if (<sub [::ws-subs/loading-config?])
       (cc/button-skeleton)
       (cc/dropdown
         {:id                   (str (:db/id party-role) "-assign-role")
          :disabled             (not add-party-permitted?)
          :label                ""
          :title-text           role-name
          :hide-label           true
          :class-name           (str "select-button"
                                     (when (and add-party-permitted?
                                                (not role-missing)) " bg-ui-gray")
                                     (when trade-missing? " warning-button"))
          :item-to-element      (partial label-element role-name tr)
          :items                (remove nil?
                                        [(when required-trade {:label :add-party-from-cr})
                                         {:label :assign-role-to-party}
                                         (when (and role-missing
                                                    (<sub [::process/signal-permitted?
                                                           parent-id
                                                           [:process.signal/mark-party-requirement-deferred]])
                                                    (= (:requirement/kind requirement) :requirement.kind/deferred-role)
                                                    (not (:requirement/deferred-by requirement)))
                                           {:label :apply-wo-role})
                                         {:label :add-new-party}
                                         (when (<sub [::process/signal-permitted?
                                                      parent-id
                                                      [:process.signal/remove-party-role-requirement
                                                       {:requirement-id (:db/id requirement)}]])
                                           {:label :remove-required-role})])
          :selected-item        role-name
          :render-selected-item (fn [selected-role]
                                  (r/as-element
                                    [:div
                                     [:div.flex (str selected-role
                                                     (when required-trade
                                                       (str " (" (tr [:party/registered]) ")")))]
                                     (when (seq parties-in-role)
                                       [:div.flex.font-light.text-xs
                                        (if (> parties-in-role-count 1)
                                          [:div.lowercase (str parties-in-role-count " " (tr [:application/parties]))]
                                          [:div.normal-case (party-model/business-or-full-name (first parties-in-role) lang)])])]))
          :on-change            #(let [selected-item (keyword (futil/oget % :selectedItem :label))]
                                   (case selected-item
                                     :add-party-from-cr (do (>evt [::party-common/init-add-from-cr (:db/id party-role)])
                                                            (>evt [::party-registered-contractor/init trade-name]))
                                     :assign-role-to-party (>evt [::party-common/init-assign-role (:db/id party-role)])
                                     :apply-wo-role (>evt [::party-common/apply-without-role (:db/id requirement) parent-id])
                                     :add-new-party (>evt [::party-common/init :invite {:party/party-roles [(:db/id party-role)]
                                                                                        :party/permissions [:party/view-other-phases
                                                                                                            :party/add-application
                                                                                                            :party/modify-application]}])
                                     :remove-required-role (>evt [::party-req-subs/remove-role-requirement-clicked
                                                                  (util/mmap {:requirement-id (:db/id requirement)} parent-id)])))}))]))

(defn- add-role-requirement
  "Dropdown for adding new party role requirements"
  [{:keys [tr parent-id]}]
  (let [title (tr [:party/add-required-role])
        open? (<sub [::add-required-role-dropdown-open? parent-id])]
    [:div#add-required-role.flex
     {:title title
      :key   "add-required-role"}
     (cc/dropdown
       {:id              "add-required-role-dropdown"
        :label           ""
        :class-name      "select-button"
        :item-to-element (fn [e]
                           (r/as-element
                             [:div.flex
                              [:div.ml-3 (futil/oget e :label)]]))
        :items           (<sub [::party-req-subs/unrequired-party-roles-sorted parent-id])
        :selected-item   {:label title}
        :downshift-props {:is-open           open?
                          :on-is-open-change #(>evt [::set-add-required-role-dropdown-open
                                                     parent-id
                                                     (futil/oget % :isOpen)])}
        :on-change       (fn [e]
                           (let [party-role-id (futil/oget e :selectedItem :id)]
                             (>evt [::set-add-required-role-dropdown-open parent-id false])
                             (>evt [::party-req-subs/add-role-requirement-clicked
                                    (util/mmap parent-id party-role-id)])))
        :title-text      title
        :hide-label      true})]))

(defn remove-role-requirement-modal
  [tr]
  (when (<sub [::party-req-subs/show-remove-party-role-req-modal?])
    (let [{:keys [parent-id requirement-id]} (<sub [::party-req-subs/party-role-modal-remove-data])]
      [ui/confirm-modal
       {:id           "remove-party-role-requirement-modal"
        :tr           tr
        :open?        true
        :on-yes-click #(>evt [::process/signal
                              parent-id
                              [:process.signal/remove-party-role-requirement (util/mmap requirement-id)]
                              {:notify {:success :party/required-role-removed}}])
        :on-close     #(>evt [::party-req-subs/close-requirement-modal-clicked])}
       (tr [:party/remove-required-role-confirm])])))

(defn- alter-role-requirement-modals
  [tr]
  [:<>
   (when (<sub [::party-req-subs/show-add-party-role-req-modal?])
     (let [{:keys [parent-id party-role-id]} (<sub [::party-req-subs/party-role-modal-add-data])]
       [ui/confirm-modal
        {:id           "add-party-role-requirement-modal"
         :tr           tr
         :open?        true
         :on-yes-click #(>evt [::process/signal
                               parent-id
                               [:process.signal/add-party-role-requirement {:role-id party-role-id}]
                               {:notify {:success :party/required-role-added}}])
         :on-close     #(>evt [::party-req-subs/close-requirement-modal-clicked])}
        (tr [:party/add-required-role-confirm])]))
   [remove-role-requirement-modal tr]])

(def role-container :div.flex.flex-row.flex-wrap.pb-4.mt-4.gap-2)

(defn requirements [{:keys [tr parties lang parent parties-w-missing-trade+role-ids]}]
  (let [missing-roles        (party-model/missing-roles parent [:requirement.kind/role :requirement.kind/deferred-role])
        parent-id            (:db/id parent)
        sort-reqs            #(-> % :requirement/party-role :party-role/names
                                  (i18n-model/get-text-from-entities-or-map lang))
        all-requirements     (req-model/phase-role-requirements parent)
        deferred-reqs        (->> all-requirements
                                  (filter :requirement/deferred-by)
                                  set)
        requirements         (->> (set/difference all-requirements deferred-reqs)
                                  (sort-by sort-reqs))
        can-add?             (<sub [::party-req-subs/can-add-role-requirement? parent-id])
        add-party-permitted? (<sub [::process/signal-permitted? parent-id [:process.signal/add-party]])]
    [:div
     [alter-role-requirement-modals tr]
     (when (or (seq requirements) can-add?)
       [:div
        [:div.bold.mb-4 (tr [:party/mandatory-roles])]
        [:div (tr [:party/mandatory-roles-info])]
        (when add-party-permitted?
          [:div.mt-4.leading-6
           [ui/button
            {:kind             :tertiary
             :on-click         #(>evt [::party-common/init :assign])
             :icon             Connect24
             :icon-description (tr [:party/assign-roles])}
            (tr [:party/assign-roles])]])
        (into
          [role-container {:key :required-roles-container}]
          (concat
            (for [{:requirement/keys [party-role] :as requirement} requirements]
              [required-role-item (util/mmap add-party-permitted? parties party-role lang missing-roles parent requirement tr parties-w-missing-trade+role-ids)])
            (when can-add?
              [[add-role-requirement (util/mmap parent-id tr)]])))])
     (when (seq deferred-reqs)
       [:div
        [:div.mt-4 (tr [:party/deferred-requirements])]
        (into
          [role-container {:key :deferred-required-roles-container}]
          (for [{:requirement/keys [party-role] :as requirement} (sort-by sort-reqs deferred-reqs)]
            [required-role-item (util/mmap add-party-permitted? parties party-role lang missing-roles parent requirement tr parties-w-missing-trade+role-ids)]))])]))
